import { TopLeftOverlay } from 'components/TopLeftOverlay/index.js'
import SurfaceFilter from 'components/SurfaceFilter/index.js'
import { TrendingIcon } from 'components/Icon/icons/trending/index.js'
import React from 'react'
import {
  STYLES_COLOR,
  STYLES_PADDING
} from 'modules/styles/constants/index.cjs'

export default function TrendingIconOverlay () {
  return (
    <TopLeftOverlay style={{
      padding: STYLES_PADDING.SMALL,
      color: STYLES_COLOR.WHITE,
      position: 'absolute',
      left: '0',
      top: '0',
      zIndex: '1',
      backgroundColor: 'transparent'
    }}
    >
      <SurfaceFilter>
        <TrendingIcon fill='white' />
      </SurfaceFilter>
    </TopLeftOverlay>
  )
}
